import { Component } from '@angular/core';
import { takeUntil } from 'rxjs';
import { WatchAwareComponent } from '../watch-aware.component';
import { Kb } from 'src/util/kb';
import { L } from 'src/sync/_api';
import { Store } from 'src/sync/store';
import { Gfx } from 'src/graphics/gfx';
import { Account } from 'src/sync/account';
import { Mouse } from 'src/graphics/mouse';

@Component({
    selector: 'app-control',
    templateUrl: './control.component.html',
    styleUrls: ['./control.component.scss'],
    standalone: false
})
export class ControlComponent extends WatchAwareComponent {
    public activeLayerId = L.Tokens;
    public showLayers = false;
    public layers: { id: L, name: string, visible: boolean, key: string }[] = [];

    public async ngOnInit() {
        const keys = Object.keys(Gfx.layers).reverse();
        for (let id of keys) {
            const index = this.layers.length;
            const layer = Gfx.layers[id];
            this.layers.push({
                id: layer.id,
                name: layer.cfg.name,
                visible: Gfx.containers.layers[id].visible,
                key: layer.cfg.hotkey.replace('Key', '')
            });
            const ksub1 = Kb.on({ code: layer.cfg.hotkey, ctrl: false, shift: false }, () => this.setActive(id as L));
            const ksub2 = Kb.on({ code: layer.cfg.hotkey, ctrl: false, shift: true }, () => this.toggleVisibility(id, index));
            this.kbsubs.push(ksub1, ksub2);
        }

        Account.settings.watch((x) => {
            this.activeLayerId = x.activeLayerId;
            this.changeDetectorRef.detectChanges();
        });

        Store.fullAccess.pipe(takeUntil(this.destroyed)).subscribe((fullAccess) => {
            this.showLayers = fullAccess;
        });
    }

    public toggleVisibility(id: string, index: number) {
        if (Store.fullAccess.value == true) {
            Gfx.containers.layers[id].visible = !Gfx.containers.layers[id].visible;
            this.layers[index].visible = Gfx.containers.layers[id].visible;
        }
    }

    public setActive(id: L) {
        Mouse.cancel();
        Account.settings.modify(x => {
            if (x.activeLayerId != L.Tokens && id == L.Tokens) {
                x.erasing = false;
            }
            x.activeLayerId = id;
        });
    }
}
